import OT from "@opentok/client";
import { toast } from "react-toastify";

import { useCallback, useEffect, useState } from "react";

import { selectAuth } from "store/auth/selectors";
import { useAppSelector } from "store/hooks";

export type Recording = {
  isRecording: boolean;
  connectionId: string | null;
};

const usePublisher = (session: OT.Session | null | undefined) => {
  const [publisher, setPublisher] = useState<OT.Publisher | null>(null);
  const [audioMuted, setAudioMuted] = useState(false);
  const [videoMuted, setVideoMuted] = useState(false);
  const [shareScreen, setShareScreen] = useState<{
    isSharing: boolean;
    publisher: OT.Publisher | null;
  }>({
    isSharing: false,
    publisher: null,
  });
  const [recording, setRecording] = useState<Recording>({
    isRecording: false,
    connectionId: null,
  });

  console.log(recording, "dgasjhdgasjhdgj");

  const auth = useAppSelector(selectAuth);
  const initialCamSettings = useAppSelector(
    (state) => state.meetings.initialCamSettings
  );

  useEffect(() => {
    if (publisher && initialCamSettings) {
      publisher.publishAudio(initialCamSettings.hasAudio);
      publisher.publishVideo(initialCamSettings.hasVideo);
      setAudioMuted(!initialCamSettings.hasAudio);
      setVideoMuted(!initialCamSettings.hasVideo);
    }
  }, [initialCamSettings, publisher]);

  const initPublisher = useCallback(() => {
    if (session) {
      const publisher = OT.initPublisher("publisher", {
        insertMode: "append",
        width: "100%",
        height: "100%",
        showControls: false,
        style: {
          backgroundImageURI: auth.user?.avatar_path || "",
        },
      });

      session.publish(publisher, (error) => {
        if (error) {
          console.log("Error publishing stream", error);
        } else {
          console.log("Published stream");
        }
      });

      setPublisher(publisher);
    }
  }, [session, auth.user?.avatar_path]);

  useEffect(() => {
    initPublisher();
  }, [session, initPublisher]);

  // useEffect(() => {
  //   if (!session) return;

  //   const handleStreamDestroyed = (event: any) => {
  //     const stream = event.stream;

  //     if (
  //       stream.videoType === "screen" &&
  //       shareScreen.publisher &&
  //       stream.connection.connectionId ===
  //         shareScreen.publisher.stream?.connection.connectionId
  //     ) {
  //       setShareScreen({
  //         isSharing: false,
  //         publisher: null,
  //       });
  //     }
  //   };

  //   session.on("streamDestroyed", handleStreamDestroyed);

  //   return () => {
  //     session.off("streamDestroyed", handleStreamDestroyed);
  //   };
  // }, [session, shareScreen.publisher]);

  //Screen sharing
  const handleCreatingShareScreenPublisherWrapper = useCallback(() => {
    const publisherWrapper = document.getElementById(
      "meeting-room-videos-area"
    );

    const screenPublisherElement = document.createElement("div");
    screenPublisherElement.id = "screen-preview";
    screenPublisherElement.style.position = "absolute";
    publisherWrapper?.appendChild(screenPublisherElement);
  }, []);

  const unpublishScreenShare = useCallback(() => {
    if (shareScreen.publisher) {
      session && session.unpublish(shareScreen.publisher);
      setShareScreen({
        isSharing: false,
        publisher: null,
      });
    }
  }, [session, shareScreen]);

  const enableScreenShare = useCallback(() => {
    unpublishScreenShare();
    !shareScreen.publisher &&
      OT.checkScreenSharingCapability((response) => {
        if (!response.supported || response.extensionRegistered === false) {
          // This browser does not support screen sharing.
          toast.error("This browser does not support screen sharing");
        } else if (response.extensionInstalled === false) {
          // Prompt to install the extension.
          toast.error(
            "Please install the screen sharing extension and try again"
          );
        } else {
          handleCreatingShareScreenPublisherWrapper();
          const shareScreenPublisher = OT.initPublisher(
            "screen-preview",
            {
              videoSource: "screen",
              width: "100%",
              height: "100%",
              showControls: false,
              publishAudio: false,
            },
            (error) => {
              if (error) {
                // Look at error.message to see what went wrong.
                console.error(error);
                setShareScreen({
                  isSharing: false,
                  publisher: null,
                });
              }
            }
          );

          session &&
            session.publish(shareScreenPublisher, (error) => {
              setShareScreen({
                isSharing: true,
                publisher: shareScreenPublisher,
              });

              if (error) {
                // Look error.message to see what went wrong.
                console.error(error);
                setShareScreen({
                  isSharing: false,
                  publisher: null,
                });
              }
            });

          shareScreenPublisher.on("destroyed", () => {
            setShareScreen({
              isSharing: false,
              publisher: null,
            });
          });
        }
      });
  }, [
    session,
    shareScreen,
    unpublishScreenShare,
    handleCreatingShareScreenPublisherWrapper,
  ]);

  shareScreen &&
    shareScreen.publisher &&
    shareScreen.publisher.on("mediaStopped", () => {
      unpublishScreenShare();
    });

  publisher &&
    publisher.on("streamDestroyed", (e) => {
      setPublisher(null);
    });

  const toggleAudio = useCallback(() => {
    if (publisher) {
      const muted = !audioMuted;
      publisher.publishAudio(!muted);
      setAudioMuted(muted);
    }
  }, [audioMuted, publisher]);

  const toggleVideo = useCallback(() => {
    if (publisher) {
      const muted = !videoMuted;
      publisher.publishVideo(!muted);

      setVideoMuted(muted);
    }
  }, [videoMuted, publisher]);

  return {
    publisher,
    toggleAudio,
    audioMuted,
    toggleVideo,
    videoMuted,
    enableScreenShare: shareScreen.isSharing
      ? unpublishScreenShare
      : enableScreenShare,
    screenShareEnabled: shareScreen.isSharing,
    isCurrUserScreenShare:
      shareScreen.publisher?.stream?.connection?.connectionId ===
      session?.connection?.connectionId,
    initPublisher,
    setShareScreen,
    recording,
    setRecording,
  };
};

export default usePublisher;
